module.exports.responsiveSlotPlacements = [
  {
    id: '/4987/puzzler',
    bidders: []
  }
];